import { render } from "./ProviderSelectionChoices.vue?vue&type=template&id=8c705244&lang=pug"
import script from "./ProviderSelectionChoices.vue?vue&type=script&lang=js"
export * from "./ProviderSelectionChoices.vue?vue&type=script&lang=js"

import "./ProviderSelectionChoices.vue?vue&type=style&index=0&id=8c705244&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__